// If type wrong url, route redirect to (404 page not found page) here
<template>
  <div class="flex justify-center content-center flex-wrap">
    <img
      class="md:pl-6"
      src="@/assets/Images/404page.gif"
      style="height:327px"
    />
  </div>
  <!-- <div class="mb-6 text-gray-800 text-center font-sans text-xl">
    <span class="opacity-50">Take me back to </span>
    <router-link
          to="/"
          class="border-b"
          >Home</router-link>
  </div> -->
</template>

<script>
export default {
  name: "NotFound",
};
</script>
